import { EValidityStatus, setBonusesAmountValidity } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import { TAppThunkDispatch, TGetState } from '~/src/store';

const validateBonusesAmount = () => {
    return (dispatch: TAppThunkDispatch, getState: TGetState): void => {
        const state = getState();
        const {
            seasonTicketPayment: {
                bonusesInfo: {
                    amount: bonusesAmount,
                },
                seasonTicket,
            },
            loyalty: {
                info: {
                    bonuses,
                },
            },
        } = state;

        const { paySum = 0 } = seasonTicket || {};

        const currPaySum = Math.floor(paySum * 100) / 100;

        const getValidity = (): EValidityStatus => {
            switch (true) {
                case !bonusesAmount:
                    return EValidityStatus.IS_LOWER_BOUND_ERROR;
                case bonusesAmount > currPaySum || bonusesAmount > bonuses:
                    return EValidityStatus.IS_UPPER_BOUND_ERROR;
                case (bonusesAmount <= currPaySum && bonusesAmount > 1):
                default:
                    return EValidityStatus.IS_VALID;
            }
        };

        const isValid = getValidity();

        dispatch(setBonusesAmountValidity(isValid));
    };
};

export default validateBonusesAmount;
